<template lang="pug">
#app
  Header
  router-view.pb-md-5
  ModalLogin
  ModalSignup
  ModalEmpresa
  Footer

  .toast-container.position-fixed.top-0.start-50.translate-middle.px-3.pt-5.mt-5
    #msg.toast.fade.text-bg-warning(role='alert' aria-live='assertive' aria-atomic='true')
      .toast-header
        i.bi.bi-bell-fill.me-1        
        strong.me-auto eBIZ Go        
        button.btn-close(type='button' data-bs-dismiss='toast' aria-label='Close')
      .toast-body {{ $store.state.MSG || 'mensaje por defecto' }}
</template>

<script>
import Header from "@/components/Header";
import ModalLogin from "@/components/ModalLogin";
import ModalSignup from "@/components/ModalSignup";
import ModalEmpresa from "@/components/ModalEmpresa";
import Footer from "@/components/Footer";
import { mapState } from "vuex";

export default {
  components: {
    Header,
    ModalLogin,
    ModalSignup,
    ModalEmpresa,
    Footer
  },

  computed: {
    ...mapState(['DATA_BASE'])
  },

  // created() {
  //   if (this.$route.name !== 'home') {
  //     this.axios.get('/go-empresa').then(({ data }) => {
  //       // console.log(data);        
  //       if (data.bodegas) {
  //         this.axios.get("/go-grupos/bodegas").then((data_bodegas) => {
  //           const data_bdgs = data_bodegas.data
  //           this.$store.commit('SET_BODEGAS', data_bdgs)
  //         })
  //       }

  //       // this.$store.commit('SET_EMPRESA', data_empresa)
  //     }).catch((err) => {
  //       console.dir(err);
  //     });
  //   }
  // }
}
</script>
